import Button from '../button/Button';
import Icon from '../icon/Icon';

interface OtrasDivisasButtonProps {
  onClick: () => void;
}

const OtrasDivisasButton = ({ onClick }: OtrasDivisasButtonProps) => (
  <Button variant="tertiary" size="sm" onClick={onClick} aria-label="Otras divisas">
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
      <Icon name="edit_outline" variant="info" modifier="regular" width={16} height={16} />
      Otras divisas
    </span>
  </Button>
);

export default OtrasDivisasButton;
